import { useLanguage } from "../i18n";

const BrandMarquee = () => {
  const { t, lang } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="brand-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#0D0F14] py-5"
    >
      <div key={lang} className="animate-marquee flex w-max items-center">
        {items.map((brand, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display px-8 text-2xl font-extrabold uppercase tracking-wide text-white/15 sm:text-3xl">
              {brand}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-[#E63946]/50" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default BrandMarquee;
